import React, { forwardRef, useImperativeHandle } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

interface RecaptchaV3Ref {
  execute: (action?: string) => Promise<string>;
}

const RecaptchaV3 = forwardRef<RecaptchaV3Ref>((_, ref) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  useImperativeHandle(ref, () => ({
    execute: async (action = 'submit'): Promise<string> => {
      if (!executeRecaptcha) {
        // reCAPTCHA not yet initialized - return empty token
        return '';
      }
      try {
        const token = await executeRecaptcha(action);
        return token;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('reCAPTCHA execution failed:', error);
        return '';
      }
    },
  }), [executeRecaptcha]);

  // No visible UI needed for v3
  return <div id="recaptchaV3" style={{ display: 'none' }} />;
});

RecaptchaV3.displayName = 'RecaptchaV3';

export default RecaptchaV3;
